// Reasons a user can give when changing a recipe's thresholds.
// `value` is the code exchanged with the API (field `eReason`), `label` is the
// French text shown in the UI. Keep the codes in sync with the backend enum.
export const REASON_OPTIONS = [
  { value: 'recipe_weakened', label: 'Recette affaiblie' },
  { value: 'recipe_strengthened', label: 'Recette renforcée' },
  { value: 'recommendation_disliked', label: "N'aime pas la recommandation" },
];

export const getReasonLabel = (value) =>
  REASON_OPTIONS.find((option) => option.value === value)?.label ?? '';
